export const useDeviceInfo = () => {
    const getOS = () => {
        if (process.server) {
            return 'unknown';
        }

        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/windows phone/i.test(userAgent)) {
            return 'windows phone';
        }

        if (/win/i.test(userAgent)) {
            return 'windows';
        }

        if (/android/i.test(userAgent)) {
            return 'android';
        }

        if (/iPad|iPhone|iPod/.test(userAgent)) {
            return 'ios';
        }

        if (/mac/i.test(userAgent)) {
            return 'macos';
        }

        if (/linux/i.test(userAgent)) {
            return 'linux';
        }

        return 'unknown';
    };

    const getBrowser = () => {
        if (process.server) {
            return 'unknown';
        }

        const ua = navigator.userAgent;

        if (ua.includes('Edg')) {
            return 'microsoft edge';
        }

        if (ua.includes('OPR') || ua.includes('Opera')) {
            return 'opera';
        }

        if (ua.includes('Chrome')) {
            return 'chrome';
        }

        if (ua.includes('Safari') && !ua.includes('Chrome')) {
            return 'safari';
        }

        if (ua.includes('Firefox')) {
            return 'firefox';
        }

        if (ua.includes('MSIE') || ua.includes('Trident/')) {
            return 'internet explorer';
        }

        return 'unknown';
    };

    return {
        os: getOS(),
        browser: getBrowser(),
    };
};
